import React from "react";
import  ReactDOM from "react-dom";
import "./style.css"
import App from "./App"


// v-17
ReactDOM.render(<App/>,document.getElementById("root"))



